/* eslint-disable */
export default {
  header: '关闭错误跟踪',
  content: '关闭错误跟踪模式将删除当前的所有错误日志。要继续吗？',
  confirm: '关闭',
  cancel: '取消',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
